import {
  wixCliAction,
  wixCliAppFlowStepsAnswers,
  wixCliAppFlowFileUploadStarted,
  wixCliAppFlowUploadEnded,
  wixCliAppsFlowDeploymentStatusSrc11Evid5232,
} from '@wix/bi-logger-dev-tools-data/v2';
import type { BiLogger } from '@wix/cli-telemetry';
import packageJson from '../../package.json' with { type: 'json' };

export const wixCliAppBiEvents = (biLogger: BiLogger) => ({
  cliAction: ({
    questionKey,
    question,
    action,
    key,
    additionalInfo,
  }: {
    questionKey: string;
    question: string;
    action: string;
    key: string;
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAction({
        questionKey,
        question,
        action,
        key,
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
  cliStepBack: ({
    additionalInfo,
  }: {
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAction({
        action: 'goToPreviousStep',
        key: 'Esc',
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
  cliFlowStepAnswered: ({
    question,
    questionKey,
    answer,
    additionalInfo,
  }: {
    question: string;
    questionKey: string;
    answer: string;
    additionalInfo?: Record<string, unknown>;
  }) => {
    void biLogger.report(
      wixCliAppFlowStepsAnswers({
        questionKey,
        question,
        answer,
        additionalInfo: JSON.stringify(additionalInfo),
      })
    );
  },
  fileUpload({
    provider,
    fileCount,
    totalSizeInKb,
  }: {
    provider: string;
    fileCount: number;
    totalSizeInKb: number;
  }) {
    const startTimestamp = Date.now();

    void biLogger.report(
      wixCliAppFlowFileUploadStarted({
        timestampMs: startTimestamp,
        hostingProvider: provider,
        numFiles: fileCount,
        fileSizeCompressed: 0,
        fileSizeNotCompressed: totalSizeInKb,
        cliVersion: packageJson.version,
      })
    );

    return {
      finished() {
        void biLogger.report(
          wixCliAppFlowUploadEnded({
            duration: Date.now() - startTimestamp,
          })
        );
      },
    };
  },
  cliDeployment: ({
    appId,
    deploymentId,
    files,
  }: {
    appId: string;
    deploymentId: string;
    files?: Array<{ filePath?: string; content?: string }>;
  }) => {
    const startTimestamp = Date.now();

    const fileDetails = files
      ? files
          .filter((f) => f.filePath)
          .map((file) => ({
            filePath: file.filePath!,
            fileSizeKb: file.content ? file.content.length / 1024 : 0,
          }))
      : [];

    return {
      finish: ({
        isSuccess,
        failureReason,
      }: {
        isSuccess: boolean;
        failureReason?: string;
      }) => {
        void biLogger.report(
          wixCliAppsFlowDeploymentStatusSrc11Evid5232({
            isSuccess,
            failureReason,
            filesDetails: JSON.stringify(fileDetails),
            filesSize: Math.round(
              fileDetails.reduce((acc, { fileSizeKb }) => acc + fileSizeKb, 0)
            ),
            uploadSource: 'backend',
            appId,
            deploymentId,
            filesUploadTime: Date.now() - startTimestamp,
          })
        );
      },
    };
  },
});
